<template>
  <div class="page-container">
    <div class="page-title-container">
      <h1 class="page-title">Vacantes</h1>
    </div>
    <div class="table-container">
      <div class="table-header">
        <div
          class="d-flex flex-column flex-md-row justify-content-between align-items-start position-relative"
        >
          <div class="w-full w-md-auto md-flex-1">
            <div
              class="d-flex justify-content-between align-items-center justify-content-lg-start"
            >
              <button
                type="button"
                class="filter d-flex align-items-center justify-content-between border-0"
                @click="showFilters = !showFilters"
              >
                <i class="ri-filter-3-line text-dark font-weight-bold"></i>
                <div>Filtrar</div>
              </button>

              <div class="d-md-none">
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold m-0"
                  v-b-tooltip.hover
                  title="Recargar"
                  @click="loadData()"
                >
                  <i class="ri-loop-right-line"></i>
                </button>
                <button
                  type="button"
                  class="button-tooltip text-dark font-weight-bold mr-0"
                  v-b-tooltip.hover
                  title="Descargar"
                  @click="downloadReport()"
                >
                  <i class="ri-download-2-line"></i>
                </button>
              </div>
            </div>
          </div>

          <section
            class="w-full w-md-auto md-flex-1 d-flex justify-content-end align-items-center mt-2 mt-md-0"
          >
            <div class="d-none d-md-flex">
              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold"
                v-b-tooltip.hover
                title="Recargar"
                @click="loadData()"
              >
                <i class="ri-loop-right-line"></i>
              </button>

              <button
                type="button"
                class="button-tooltip text-dark font-weight-bold ml-0"
                v-b-tooltip.hover
                title="Descargar"
                @click="downloadReport()"
              >
                <i class="ri-download-2-line"></i>
              </button>
            </div>

            <div class="w-full w-md-auto d-flex flex-column flex-md-row">
              <SearchBar
                placeholder="Buscar por código de vacante o nombre del solicitante"
                @search="onSearch"
                @input="search = $event"
                class="flex-1"
              />

              <div class="text-right mt-2 mt-md-0">
                <b-button
                  :to="{ name: 'applicants-create' }"
                  variant="none"
                  class="button button-primary ml-md-2"
                  >Agregar</b-button
                >
              </div>
            </div>
          </section>

          <filter-menu
            :show="showFilters"
            @hide="showFilters = false"
            :options="filterOptions"
            :selectedOptionFilter="filters"
            @setFilters="setFilters"
          ></filter-menu>
        </div>

        <div
          class="w-100 d-flex flex-wrap align-items-center mt-2"
          v-if="showFiltersList"
        >
          <span
            v-for="(val, name) in filterList"
            v-bind:key="name"
            class="filter-item"
          >
            {{ getFilterName(name, val) }}
            <button
              type="button"
              class="text-white p-0 bg-transparent border-0 ml-2"
              @click="deleteFilter(name)"
            >
              <i class="ri-close-circle-line"></i>
            </button>
          </span>
        </div>
      </div>

      <div>
        <!-- Mobile -->
        <div class="custom-table-mobile d-xl-none">
          <section class="custom-table-mobile-header">
            <div>
              <span>Código de vacante</span>
            </div>

            <div>
              <span>Fecha de creación</span>
            </div>
          </section>

          <div class="custom-table-mobile-body">
            <div class="custom-table-mobile-row" v-for="o in list" :key="o.id">
              <div class="custom-table-mobile-grid">
                <div>
                  <span>{{ o.code }}</span>
                </div>

                <div>
                  <span>{{ `${o.name} ${o.surname}` }}</span>
                </div>
                <div>
                  <button
                    type="button"
                    class="border-0 bg-transparent"
                    @click="o.showMobileData = !o.showMobileData"
                  >
                    <span v-if="!o.showMobileData">
                      <i class="ri-arrow-down-s-line"></i>
                    </span>
                    <span v-else>
                      <i class="ri-arrow-up-s-line"></i>
                    </span>
                  </button>
                </div>
              </div>

              <div class="custom-table-mobile-options mt-3">
                <router-link
                  :to="{ name: 'employee-details', params: { id: o.id } }"
                >
                  Ver detalle
                </router-link>

                <router-link
                  :to="{ name: 'employee-edit', params: { id: o.code } }"
                  class="mx-3"
                >
                  Editar
                </router-link>

                <!-- <a href="" @click.prevent="openChangeStatus(o)">
                  {{ getStatus(o.status).action }}
                </a> -->
              </div>

              <div class="pt-3" v-if="o.showMobileData">
                <ul class="list-unstyled p-0">
                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Cargo:</span
                    >
                    <span>{{ o.role }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Área:</span
                    >
                    <span>{{ o.area }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Solicitado por:</span
                    >
                    <span>{{ o.createdBy }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Total de Postulantes:</span
                    >
                    <span>{{ o.total }}</span>
                  </li>

                  <li>
                    <span class="font-weight-medium d-inline-block mr-2"
                      >Estado:</span
                    >
                    <span :class="`badge ${getStatus(o.status).color}`">{{
                      getStatus(o.status).label
                    }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Desktop -->
        <table class="custom-table w-100 d-none d-xl-table">
          <thead>
            <tr>
              <th>Código de Vacante</th>
              <th>Fecha de <br> creación</th>
              <th>Cargo</th>
              <th>Área</th>
              <th>Solicitado por</th>
              <th>Total de <br> Postulantes</th>
              <th>Estado</th>
              <th class="pr-md-3">Opciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="o in list" :key="o.id">
              <td class="cell-center pl-3">{{ o.code }}</td>
              <td class="text-center" v-date="o.createdAt"></td>
              <td class="cell-center">{{ o.role }}</td>
              <td class="text-center">{{ o.area }}</td>
              <td class="cell-center">{{ o.createdBy || '-' }}</td>
              <td class="cell-center">{{ o.total || '-' }}</td>
              <td class="cell-center pl-md-2">
                <span :class="`badge ${getStatus(o.status).color}`">{{
                  getStatus(o.status).label
                }}</span>
              </td>
              <td class="cell-center d_option pr-md-2 position-relative">
                <DropdownTable>
                  <template slot="dropdown-content">
                    <DropdownItem
                      text="Ver datos"
                      :to="{
                        name: 'employee-details',
                        params: { id: o.id },
                      }"
                    />
                    <DropdownItem
                      text="Editar"
                      :to="{
                        name: 'employee-edit',
                        params: { id: o.id },
                      }"
                    />
                    <!-- <DropdownItem
                      :text="getStatus(o.status).action"
                      @click="openChangeStatus(o.id, EmployeeStatus.INACTIVE.key)"
                    /> -->
                  </template>
                </DropdownTable>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-footer d-flex justify-content-end align-items-center">
        <pagination
          :total="total"
          :page="page"
          :page-size="pageSize"
          :pages="pages"
          :changePage="changePage"
          :changePageSize="changePageSize"
          v-if="list.length"
        />

        <div class="table-no-results" v-else>
          <p class="m-0 px-3">No se encontraron resultados.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Constants,
  Util,
  Alert,
  FilterMenu,
  FilterMixin,
  PaginationMixin,
  DropdownTable,
  DropdownItem,
  SearchBar,
} from "wize-admin";

import { Constants as LocalConstants } from "@/core/utils";
import { EmployeeService } from "@/core/services";
// import fileDownload from "js-file-download";

export default {
  components: {
    SearchBar,
    DropdownTable,
    DropdownItem,
    FilterMenu,
  },
  data() {
    return {
      list: [],
      EmployeeStatus: LocalConstants.EmployeeStatus,
      tooltipType: null,
      filterOptions: [
        {
          label: "Estado",
          key: "status",
          type: Constants.TypeFilters.SINGLE,
          options: [
            LocalConstants.EmployeeStatus.ACTIVE,
            LocalConstants.EmployeeStatus.INACTIVE
          ],
        }
      ],
    };
  },
  mixins: [PaginationMixin, FilterMixin],
  methods: {
    async loadData() {
      try {
        await this.$store.dispatch("app/loading", true);
        const params = {
          page: this.page - 1,
          size: this.pageSize,
          sort: "id",
        };
        const data = { search: this.search, ...this.filters };
        const response = await EmployeeService.list(data, params);

        this.list = response.payload.content.map((item) => {
          return {
            ...item,
            showMobileData: false
          };
        });

        this.total = response.payload.totalElements;
        this.pages = response.payload.totalPages;
      } catch (e) {
        console.error(e);
        Alert.error(e.errors.message);
      } finally {
        await this.$store.dispatch("app/loading", false);
      }
    },
    getStatus(key) {
      let keyInt = parseInt(key)
      return Util.searchValue(keyInt, LocalConstants.EmployeeStatus);
    },
    getIdentifierType(key) {
      return Util.searchValue(key, LocalConstants.IdentifierType)
    },
    // openChangeStatus(supplierId, status) {
    //   const self = this;
    //   Alert.dialog(
    //     "¿Desea cambiar el estado del proveedor?",
    //     null,
    //     async function () {
    //       try {
    //         await self.$store.dispatch("app/loading", true);
    //         const resp = (
    //           await EmployeeService.changeStatus(supplierId, status)
    //         ).payload;

    //         const obj = self.list.find((o) => {
    //           return o.id === resp.id;
    //         });
    //         if (obj) {
    //           const index = self.list.indexOf(obj);
    //           self.$set(self.list, index, resp);
    //         }
    //         Alert.success("Estado actualizado correctamente");
    //       } catch (e) {
    //         console.error(e);
    //         Alert.error(e.errors.message);
    //       } finally {
    //         await self.$store.dispatch("app/loading", false);
    //       }
    //     }
    //   );
    // },
    // async downloadReport() {
    //   try {
    //     await this.$store.dispatch("app/loading", true);
    //     const data = { search: this.search, ...this.filters };
    //     const response = await EmployeeService.download(data);
    //     fileDownload(response.data, Util.getFileName(response));
    //   } catch (error) {
    //     console.error(error);
    //     Alert.error(error);
    //   } finally {
    //     await this.$store.dispatch("app/loading", false);
    //   }
    // },
  },
  async created() {
    // await this.loadData(this.page, this.pageSize);
  },
};
</script>

<style lang="stylus">
@import '../Styles/supplier-list';
</style>
